export default __webpack_public_path__ + "static/key-brain--green-e22f27e13c7c340f3b17c79c14fc3002.png";